<template>
  <div>
    <v-row
      class="prize-item prize-card-item"
      v-for="prize in prizes.entries"
      :key="prize.identifier"
      no-gutters
    >
      <v-col md="6" class="next-drawing-text prize-name">
        {{ prize.name }} - 1X :</v-col
      >
      <v-col md="6" class="amount">
        <span> {{ prize.amount }} </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "PrizesCard",
  inject: ["contentStatus"],
  props: {
    prizes: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "css/variables";

.prize-item {
  font-family: "MontHeavy", serif;
  font-size: 1.5rem;
  line-height: 1.5rem;

  .amount {
    font-size: 2.3rem;
    color: $yellow;
    width: 300px;
    height: 50px;
    text-align: right;
    align-items: center;
    justify-content: flex-end;
    display: flex;
    padding-right: 15px;
  }
}
.prize-card-item {
  background-color: $dark-blue;
  padding-left: 15px;
  border-radius: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.justify-content-space-evenly {
  justify-content: space-evenly;
}

.next-drawing-text {
  color: white;
}

.prize-name {
  align-items: center;
  display: flex;
  color: white;
}
</style>
